var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
import { selectKeyPath } from '@odc/odbelt'
import classNames from 'classnames'
import { useFormikContext } from 'formik'
import React from 'react'
// @ts-ignore
import { InputAdapter, TextMask } from 'react-text-mask-hoc'
import { FormFeedback, Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'
import styled from 'styled-components'
import { useODEntityContext } from '../../..'
import { ODIcon } from '../../../../../icons'
import { useGlobalContext } from '../../../../global'
import { ODEntityState } from '../../../context/reducer'
import { ODEntityLabeled } from './ODEntityLabeled'
var CustomInput = styled(Input)(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      [
        '\n  :focus {\n    outline: none !important;\n    border: 1px solid ',
        ' !important;\n    box-shadow: 0 0 4px ',
        ' !important;\n  }\n',
      ],
      [
        '\n  :focus {\n    outline: none !important;\n    border: 1px solid ',
        ' !important;\n    box-shadow: 0 0 4px ',
        ' !important;\n  }\n',
      ]
    )),
  function (p) {
    return p.box_color
  },
  function (p) {
    return p.box_shadow_color
  }
)
export var InputWithIcon = function (props) {
  var children = props.children,
    icon = props.icon,
    iconAppend = props.iconAppend,
    _a = props.iconProps,
    iconProps = _a === void 0 ? {} : _a
  if (icon) {
    var IconElement = React.createElement(
      InputGroupAddon,
      { addonType: iconAppend ? 'append' : 'prepend' },
      React.createElement(InputGroupText, null, React.createElement(ODIcon, __assign({ icon: icon }, iconProps)))
    )
    return React.createElement(InputGroup, null, !iconAppend && IconElement, children, iconAppend && IconElement)
  }
  return React.createElement(React.Fragment, null, children)
}
export function ODEntityInput(props) {
  var name = props.name,
    keyPath = props.keyPath,
    _a = props.label,
    label = _a === void 0 ? 'NO LABEL TEXT' : _a,
    placeholder = props.placeholder,
    _b = props.inputType,
    inputType = _b === void 0 ? 'text' : _b,
    autoComplete = props.autoComplete,
    icon = props.icon,
    iconAppend = props.iconAppend,
    required = props.required,
    readOnly = props.readOnly,
    autoFocus = props.autoFocus,
    useValidChecker = props.useValidChecker,
    appendChildren = props.appendChildren,
    prependChildren = props.prependChildren,
    children = props.children,
    mask = props.mask,
    rows = props.rows,
    _c = props.inputProps,
    inputProps = _c === void 0 ? {} : _c,
    _d = props.iconProps,
    iconProps = _d === void 0 ? {} : _d,
    options = props.options,
    hideIfCreating = props.hideIfCreating,
    _e = props.withoutLabel,
    withoutLabel = _e === void 0 ? false : _e
  var formikContext = useFormikContext()
  var convertThemeString = useGlobalContext().convertThemeString
  var customInputProps = {
    box_shadow_color: convertThemeString('{{primary}}'),
    box_color: convertThemeString('{{primary}}'),
  }
  if (rows !== undefined) {
    // @ts-ignore
    inputProps.rows = rows
  }
  if (!formikContext) {
    return null
  }
  var entityContext = useODEntityContext()
  if (entityContext && hideIfCreating) {
    var isCreating = [ODEntityState.LoadedInitialForCreation, ODEntityState.SavingCreates].includes(
      entityContext.state.state
    )
    if (isCreating) {
      return null
    }
  }
  var errors = formikContext.errors,
    touched = formikContext.touched,
    handleChange = formikContext.handleChange,
    handleBlur = formikContext.handleBlur,
    values = formikContext.values,
    isSubmitting = formikContext.isSubmitting
  // @ts-ignore
  var value = selectKeyPath(keyPath)(values, '')
  // @ts-ignore
  var error = errors[name]
  // @ts-ignore
  var touchedElement = !!touched[name]
  var inputItem = (function () {
    if (mask) {
      return React.createElement(
        InputWithIcon,
        { icon: icon, iconAppend: iconAppend, iconProps: iconProps },
        React.createElement(
          TextMask,
          __assign(
            {
              id: name + '-input',
              name: name,
              mask: mask,
              Component: InputAdapter,
              className: classNames('form-control', { 'is-invalid': touchedElement && !!error }),
              onChange: handleChange,
              onBlur: handleBlur,
              value: value,
              disabled: isSubmitting,
            },
            inputProps
          )
        ),
        error && React.createElement(FormFeedback, { style: { display: 'block' } }, error)
      )
    }
    return React.createElement(
      InputWithIcon,
      { icon: icon, iconAppend: iconAppend, iconProps: iconProps },
      React.createElement(
        CustomInput,
        __assign(
          {
            readOnly: readOnly,
            type: inputType,
            id: name + '-input',
            name: name,
            placeholder: placeholder,
            autoComplete: autoComplete,
            valid: useValidChecker && touchedElement && !error,
            invalid: touchedElement && !!error,
            autoFocus: !!autoFocus,
            required: !!required,
            onChange: handleChange,
            onBlur: handleBlur,
            value: value,
            disabled: isSubmitting,
          },
          inputProps,
          customInputProps
        ),
        options
      ),
      error && React.createElement(FormFeedback, null, error)
    )
  })()
  if (withoutLabel) {
    return React.createElement(
      React.Fragment,
      null,
      children &&
        React.createElement(
          'div',
          { style: { display: 'flex', width: '100%' } },
          prependChildren && children,
          inputItem,
          appendChildren && children
        ),
      !children && inputItem
    )
  }
  return React.createElement(
    ODEntityLabeled,
    { name: name, label: label },
    children &&
      React.createElement(
        'div',
        { style: { display: 'flex', width: '100%' } },
        prependChildren && children,
        inputItem,
        appendChildren && children
      ),
    !children && inputItem
  )
}
var templateObject_1
//# sourceMappingURL=ODEntityInput.js.map
